<i18n>
{
  "fr": {
    "createControl": "Créer un contrôle",
    "type": "Type",
    "date": "Date",
    "dateOfVisit": "Date de visite",
    "updatedAt":"Date dernière modification",
    "createdBy": "Effectuée par",
    "status": "Etat",
    "noControlFound": "Aucun contrôle trouvé",
    "property": "propriété",
    "conformite": "Conformité",
    "vpt": "Visite Pendant Travaux",
    "exploitation": "Visite d'Entretien",
    "adminData": "Administratives",
    "conceptionData": "Conception",
    "connectionData": "Raccordements",
    "contactData": "Contacts",
    "schemas": "Schémas",
    "attachFiles": "Pièces jointes",
    "actions": "Actions",
    "technical": "Technique",
    "synoptic": "Synoptique",
    "loading": "Chargement...",
    "download": "Télécharger",
    "deleteProperty": "Supprimer la propriété",
    "delete_property_confirmation_message": "Attention ! Vous vous apprêtez à supprimer la propriété. La suppression est définitive. La propriété sera effacée de la base ainsi que tout les contrôles qui y sont rattaché. Apres validation de la suppression, il ne sera plus possible de revenir en arrière. Vous confirmez ?"
    }
}
</i18n>

<template>
  <div>
    <InfoBar :detail="true" />
    <b-card
      body-class="pd-0"
      header-class="bg-transparent bd-b-1"
      class="card-hover card-suze mg-t-10"
    >
      <template v-slot:header>
        <h6></h6>
        <div class="d-flex">
          <div class="dropdown show pull-right">
            <b-dropdown
              id="dropdownMenuLink"
              v-bind:text="$t('createControl')"
              class="pull-right margin-bottom-8"
              toggle-class="btn btn-cta s-btn"
              no-caret
            >
              <router-link
                tag="b-dropdown-item"
                :to="{ name: 'conformite_create', params: { propertyId: property.id } }"
              >{{ $t('conformite') }}</router-link>

              <router-link
                tag="b-dropdown-item"
                :to="{ name: 'vpt_create', params: { propertyId: property.id } }"
              >{{ $t('vpt') }}</router-link>

              <router-link
                tag="b-dropdown-item"
                :to="{ name: 've_create', params: { propertyId: property.id } }"
              >{{ $t('exploitation') }}</router-link>
            </b-dropdown>
          </div>
        </div>
      </template>
      <div :class="{noActive : isNoActive }" class="property-detail">
        <div :class="{ 'no-data-message': isNoActive }" class="message">
          <div class="content">
            <h4 class="align-center">
              <slot name="Loading">{{ this.$i18n.t('loading') }}</slot>
            </h4>
          </div>
        </div>
        <div :class="{ 'no-data': isNoActive }">
          <div v-if="getNotif.label" class="block-alert">
            <div lg="12">
              <b-alert :variant="getNotif.label" show dismissible>{{ getNotif.message }}</b-alert>
            </div>
          </div>
          <div class>
            <div class>
              <table class="table table-striped admin-list">
                <thead>
                  <tr class="thead-color">
                    <th scope="col">{{ $t('type') }}</th>
                    <th scope="col">{{ $t('dateOfVisit') }}</th>
                    <th scope="col">{{ $t('status') }}</th>
                    <th scope="col">{{ $t('updatedAt') }}</th>
                    <th scope="col">{{ $t('createdBy') }}</th>
                    <th scope="col">{{ $t('actions') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-if="getControls.length > 0 && !loaderControls">
                    <tr v-for="control in getControls" :key="control.id" class="request_row">
                      <td>{{ control.type }}</td>
                      <td>{{ control.data.dateOfVisit | moment('DD/MM/YYYY') }}</td>
                      <td>{{ control.currentStatus.status.label }}</td>
                      <td>{{ control.currentStatus.updatedAt | moment('DD/MM/YYYY HH:mm') }}</td>
                      <td>{{ control.currentStatus.applicationUser.firstName }} {{ control.currentStatus.applicationUser.lastName }}</td>
                      <td>
                        <b-link @click="onDetailControl(control.id,control.type)">
                          <v-icon name="eye" />
                        </b-link>
                        <b-link
                          v-if="isWrite(control.currentStatus.status.id)"
                          @click="onEditControl(control.id,control.type)"
                        >
                          <v-icon name="edit" />
                        </b-link>
                        <b-link
                          v-show="isMailPermitted(control.currentStatus.status.id)"
                          @click="onMailManagementIndex(control.id, control.type)"
                        >
                          <v-icon name="file-contract" />
                        </b-link>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
              <div class="account-error-div" v-if="getControls.length == 0 || loaderControls">
                <template v-if="loaderControls">
                  <strong>{{$t('loading')}}</strong>
                  <b-spinner class="ml-auto"></b-spinner>
                </template>
                <template v-else-if="error">
                  <v-icon name="exclamation-triangle" />
                  <p>{{ $t('error') }}</p>
                </template>
                <template v-else>
                  <v-icon name="info-circle" />
                  <p>{{ $t('noControlFound') }}</p>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-card>

    <b-card body-class="pd-0" class="card-hover card-suze mg-t-10">
      <div id="property-data">
        <div class="buttons-group">
          <b-button v-b-toggle.adminData class="btn-data">
            <v-icon name="info" />
            {{ $t('adminData') }}
          </b-button>
          <b-button v-b-toggle.conceptionData class="btn-data">
            <v-icon name="map" />
            {{ $t('conceptionData') }}
          </b-button>
          <b-button v-b-toggle.connectionData class="btn-data">
            <v-icon name="plug" />
            {{ $t('connectionData') }}
          </b-button>
          <b-button
            v-if="property.contacts && property.contacts.length > 0"
            v-b-toggle.contactData
            class="btn-data"
          >
            <v-icon name="users" />
            {{ $t('contactData') }}
          </b-button>
          <b-button
            v-b-toggle.schemasData
            class="btn-data"
          >
            <v-icon name="map" />
            {{ $t('schemas') }}
          </b-button>

          <b-button
            v-b-toggle.attachFiles
            class="btn-data"
          >
            <v-icon name="file" />
            {{ $t('attachFiles') }}
          </b-button>

        </div>
        <b-collapse id="adminData" accordion="accordion-data-property">
          <b-card>
            <AdminData />
          </b-card>
        </b-collapse>
        <b-collapse id="conceptionData" accordion="accordion-data-property">
          <b-card>
            <ConceptionData />
          </b-card>
        </b-collapse>
        <b-collapse id="connectionData" accordion="accordion-data-property">
          <b-card>
            <ConnectionData />
          </b-card>
        </b-collapse>
        <b-collapse id="contactData" accordion="accordion-data-property">
          <b-card>
            <ContactData />
          </b-card>
        </b-collapse>
        <b-collapse id="schemasData" accordion="accordion-data-property">
          <b-card>
            <div class="row">
              <div v-if="property.technicalDrawingImage" class="col-sm-6 text-center">
                <h4 class="header-title">{{ $t('technical') }}</h4>
                <img v-bind:src="getFileUrl(property.technicalDrawingImage.id)" class="img-responsive">
                <br>
                <a v-bind:href="getFileUrl(property.technicalDrawingImage.id)" target="_blank">{{ $t('download') }}</a>
              </div>
              <div v-if="property.synopticDrawingImage" class="col-sm-6 text-center">
                <h4 class="header-title">{{ $t('synoptic') }}</h4>
                <img v-bind:src="getFileUrl(property.synopticDrawingImage.id)" class="img-responsive">
                <br>
                <a v-bind:href="getFileUrl(property.synopticDrawingImage.id)" target="_blank">{{ $t('download') }}</a>
              </div>
            </div>
          </b-card>
        </b-collapse>

       
        <b-collapse id="attachFiles" accordion="accordion-data-property">
          <b-card>
             <FilesData :attachment="property.conception.attachement" />
          </b-card>
        </b-collapse>

      </div>
    </b-card>
    
    <br>

    <button v-show="canDeleteProperty()"
      class="btn btn-danger s-btn-danger pull-right" v-on:click="deleteProperty()"
    >{{ $t('deleteProperty') }}</button>
  </div>
</template>

<script>
import AdminData from './AdminData';
import ConceptionData from './ConceptionData';
import ConnectionData from './ConnectionData';
import ContactData from './ContactData';
import InfoBar from './InfoBar';
import { mapGetters, mapState, mapActions } from 'vuex';
import { getEndpoint } from '../../store/endpoints';
import axios from 'axios';
import VueJwtDecode from 'vue-jwt-decode';
import FilesData from './FilesData';
export default {
  name: 'property',
  components: {
    AdminData,
    ConceptionData,
    ConnectionData,
    FilesData,
    ContactData,
    InfoBar,
  },
  data: () => ({
    loaderControls: true,
    error: false,
    isNoActive: true,
    eServices: null,
  }),
  computed: {
    ...mapState({ property: state => state.refProperties.property }),
    ...mapGetters(['getControls', 'getNotif']),
  },
  created: function() {
    this.setIdProperty();
    this.fetchControls();
    this.fetchTowns();
  },
  mounted () {
    this.jwtDecoded = VueJwtDecode.decode(this.$store.state.app.parameters.jwt);
    this.contractId = this.jwtDecoded.data.user.contractsIds[0];
    this.eServices = this.jwtDecoded.data.user.eServices;
  },
  methods: {
    ...mapActions(['fetchTowns']),
    isMailPermitted(status) {
      let visible = {
        new: false,
        inProgress: false,
        waitingForValidation: false,
        closed: true,
        generatedMail: true,
        validated: true,
      };
      return visible[status];
    },
    isWrite(status) {
      let visible = {
        new: true,
        inProgress: true,
        waitingForValidation: false,
        closed: false,
        generatedMail: false,
        validated: false,
      };
      return visible[status];
    },
    setIdProperty() {
      this.$store.dispatch('setIdProperty', { id: this.$route.params.propertyId });
      this.$store
        .dispatch('fetchProperty', { id: this.$route.params.propertyId })
        .then(() => (this.isNoActive = false));
    },
    fetchControls() {
      this.$store.dispatch('fetchControls', { id: this.$route.params.propertyId }).then(
        () => {
          this.loaderControls = false;
        },
        error => {
          console.log(error.message);
          this.loaderControls = false;
          this.error = true;
        }
      );
    },
    onDetailControl(controlId, typeControl) {
      const type = typeControl.toLowerCase();
      this.$router.push({
        name: `${type}_detail`,
        params: { controlId: controlId, propertyId: this.$route.params.propertyId },
      });
    },
    onEditControl(controlId, typeControl) {
      const type = typeControl.toLowerCase();

      this.$router.push({
        name: `${type}_edit`,
        params: { controlId: controlId, propertyId: this.$route.params.propertyId },
      });
    },
    onMailManagementIndex(controlId, controlType) {
      const type = controlType.toLowerCase();

      this.$router.push({
        name: `MailManagementIndex`,
        params: { controlId: controlId, controlType: type,propertyId: this.$route.params.propertyId },
      });
    },
    getFileUrl: function (fileId) {
      return getEndpoint('properties', null, null, fileId, null).absoluteDownloadUrl;
    },
    deleteProperty() {
      if (! confirm(this.$t('delete_property_confirmation_message'))) {
        return false;
      }

      let endpoint = getEndpoint('properties', this.$route.params.propertyId, null, null).delete;
      let _this = this;
      axios.delete(endpoint).then(function () {
        _this.$router.push({
          name: `properties`,
        });
      });
    },
    canDeleteProperty() {
      if (this.contractId) {
        if (this.eServices[this.contractId]['PROPERTIES']['DELETE'] === true) {
          return true;
        }        
      }

      return false;
    },
  },
};
</script>
